module.exports = __webpack_public_path__ + "img/jj_2.35cf000d.png";